import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const dialogContainer = {

  [`MuiBackdrop-root`]:{
    opacity: 0.3,
    backgroundColor: 'rgb(255 255 255 / 10%)',
  },
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",
    justifyContent: "flex-end",

    [`.MuiDialog-paper`]: {
      margin: "20px",
      boxShadow: "none",
    },
  },
};

export default function AddNewEditorModal({
  open,
  onClose,
  scroll,
  children,
  hideBackdrop,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      hideBackdrop={hideBackdrop}
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      scroll={scroll}
      aria-labelledby="responsive-dialog-title"
      className="addNewModal"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "812px",
          borderRadius: "13px",
          minHeight: "calc(100vh - 40px)",

          [`& .MuiDialogContent-root`]: {
            padding: "0 24px 0 36px",
            position: "relative",
          },
        },
      }}
      sx={dialogContainer}
    >
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
